import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function DrawerSkeleton() {
  return (
    <div className="relative z-10">
      <div className="fixed inset-0 bg-transparent bg-opacity-40 backdrop-blur-sm backdrop-filter transition-opacity duration-500 ease-in-out" />
      <div className="fixed inset-0 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full ">
            <div className="pointer-events-auto relative w-screen max-w-md transform transition duration-500 ease-in-out sm:duration-700">
              <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl w-11/12 md:w-full">
                <div className="px-4 sm:px-6 w-11/12 m-auto rounded-lg max-h-60 pb-7">
                  <div className="w-[19rem] md:w-[22.5rem] h-[12rem] mt-5 absolute">
                    <Skeleton
                      width="100%"
                      height="100%"
                      className="rounded-sm"
                    />
                  </div>
                </div>
                <div className="relative mt-6 flex-1 px-4 sm:px-6 mt-60">
                  <div className="mb-3 ml-1">
                    <Skeleton width={200} height={24} />
                  </div>
                  <div className="flex items-center justify-between space-x-5">
                    <Skeleton width={160} height={36} />
                    <Skeleton width={160} height={36} />
                  </div>
                  <div className="px-1.5 mt-3">
                    <div className="border-b border-gray-100 py-3 flex justify-between">
                      <Skeleton width={120} height={24} />
                      <Skeleton width={60} height={24} />
                    </div>
                    <div className="border-b border-gray-100 py-3 flex justify-between">
                      <Skeleton width={120} height={16} />
                      <Skeleton width={80} height={16} />
                    </div>
                    <div className="border-b border-gray-100 py-3 flex justify-between">
                      <Skeleton width={120} height={16} />
                      <Skeleton width={80} height={16} />
                    </div>
                    <div className="border-b border-gray-100 py-3 flex justify-between">
                      <Skeleton width={120} height={16} />
                      <Skeleton width={80} height={16} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
